<template>
    <section class=" -mt-28 py-12">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          <div
            v-for="dominio in dominios"
            :key="dominio.extensao"
            class="bg-white rounded-2xl shadow-md  flex flex-col justify-between p-14 space-y-8 "
          >
            <div>
              <div class="text-7xl font-bold mb-10 " :style="{ color: dominio.cor }">
                {{ dominio.icone }}
              </div>
              <h2 class="text-xl font-bold text-black ">{{ dominio.extensao }}</h2>
              <p class="text-gray-500 mb-8">Registre seu domínio {{ dominio.extensao }}</p>
              <p class="text-gray-500 text-sm italic mb-2">a partir:</p>
              <p class="text-3xl font-bold mb-2" :style="{ color: dominio.cor }">
                R${{ dominio.preco }},00
                <span class="text-sm font-medium text-gray-600">/ano*</span>
              </p>
            </div>
            <p class="text-xs text-gray-500 mt-4">* consulte valor do domínio com o nosso comercial</p>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const dominios = [
    {
      icone: '.com',
      extensao: '.com',
      preco: 75,
      cor: '#ff6584' // rosa
    },
    {
      icone: '.net',
      extensao: '.net',
      preco: 75,
      cor: '#8e4a9d' // roxo escuro
    },
    {
      icone: '.com.br',
      extensao: '.com.br',
      preco: 40,
      cor: '#715682' // roxinho claro
    }
  ]
  </script>
  